import { jsx } from "react/jsx-runtime";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { validateTidalLicense } from "../../base/index.js";
function Fullscreen(props) {
  return /* @__PURE__ */ jsx(
    FullscreenIcon,
    {
      "data-testid": "Fullscreen",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Fullscreen",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Fullscreen.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Fullscreen"
};
validateTidalLicense();
export {
  Fullscreen
};
//# sourceMappingURL=Fullscreen.js.map
